import { Actions as CommonActions, type ReportModuleLoadingData } from "@client/actions";
import loader from "@client/lib/loader";
import { loaderArgsSelector } from "@client/selectors";
import { type AppState } from "@client/types/AppState";
import { type ReduxAction } from "@client/types/ReduxAction";
import Deferred from "@common/lib/deferred";
import { type Dispatch, type MiddlewareAPI } from "redux";

export default () => {
  const tracker = (() => {
    let loadedDeferred = new Deferred();
    let waiting = {};

    const checkLoaded = () => {
      if (Object.keys(waiting).every((k) => !waiting[k])) {
        loadedDeferred.resolve();
      }
    };
    return {
      report: (data: ReportModuleLoadingData) => {
        // we may get modules from a non-current page. That’s fine, since the value will be false
        waiting[data.moduleId] = data.isLoading;
        checkLoaded();
      },
      reset: () => {
        loadedDeferred = new Deferred();
        waiting = {};
      },
      wait: (): Deferred<any> => {
        checkLoaded();

        return loadedDeferred;
      }
    };
  })();

  return (api: MiddlewareAPI<Dispatch<any>, AppState>) => (next) => (action: ReduxAction<any>) => {
    next(action);

    const loaderArgs = loaderArgsSelector(api.getState());
    switch (action.type) {
      case CommonActions.LoadPageBegin: {
        tracker.reset();

        const loaderArgs = loaderArgsSelector(api.getState());
        if (loaderArgs) {
          loader.show(loaderArgs);
        }
        break;
      }
      case CommonActions.LoadPageFailure:
      case CommonActions.LoadPageSuccess:
      case CommonActions.InitSuccess:
      case CommonActions.SsrInit: {
        // TODO: try remove (we need it because init actions won't dispatch immediately);
        setTimeout(() => {
          const waiter = loaderArgs?.waitAllModules ? tracker.wait() : new Deferred().resolve();
          waiter.promise.then(() => {
            loader.hide();
          });
        }, 0);
        break;
      }
      case CommonActions.ReportModuleLoading: {
        tracker.report(action.data as ReportModuleLoadingData);
        break;
      }
    }
  };
};
